<template>
  <v-container fluid style="padding: 24px 14px;">

    <!-- Dialog Edit PDPA Setting alert -->
    <div class="text-xs-center">
        <v-dialog
        v-model="isDialogEditSettingPDPAShown"
        persistent
        width="900"
            >
            <v-card>
                <v-card-title
                    class="headline light-blue darken-3 text-light"
                    primary-title
                >
                    Edit PDPA Setting Alert
                    <v-spacer></v-spacer>
                        <v-btn icon dark @click="isDialogEditSettingPDPAShown = false" style="outline: none;">
                            <v-icon>close</v-icon>
                        </v-btn>
                </v-card-title>
                <v-flex lg12 md12 id="tabele-device">
                    <v-flex text-lg-right mb-3>
                        <v-btn @click="addSettingAlert" style="outline: none;">
                            <v-icon dark class="mr-2">
                                mail_outline
                            </v-icon>
                            <span id='btn-box-inside'>Add Email</span>
                        </v-btn>
                    </v-flex>
                    <v-card >
                        <v-data-table
                            :headers="headersSettingAlert"
                            :items="settingAlertable"
                            :loading="loadTableSettingAlert"
                            :pagination.sync="paginationSettingAlert"
                            >
                            <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-center">{{ props.item.email }}</td>
                                <td class="text-xs-center">{{ props.item.time }}</td>
                                <td class="text-xs-center">
                                    <div id="btn-box">
                                        <v-switch
                                            v-model="props.item.sendemail"
                                            :label="props.item.sendemail.toString()"
                                            color="success"
                                            @change="switchBTNSettingOneAlert(props.item)"
                                            hide-details
                                            >
                                        </v-switch>
                                    </div>
                                </td>
                                <td class="i-xs-center" >
                                    <v-tooltip bottom>
                                        <v-btn
                                            slot="activator"
                                            flat
                                            icon
                                            style="outline: none;"
                                            @click="editSettingOneAlert(props.item)">
                                            <v-icon size="24">edit</v-icon>
                                        </v-btn>
                                        <span>Edit</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <v-btn
                                            slot="activator"
                                            flat
                                            icon
                                            style="outline: none;"
                                            @click="deleteSettingAlert(props.item)">
                                            <v-icon size="22">delete_outline</v-icon>
                                        </v-btn>
                                        <span>Delete</span>
                                    </v-tooltip>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-card>
        </v-dialog>
    </div>

    <!-- Dialog Edit Index PDPA -->
    <div class="text-xs-center">
        <v-dialog
        v-model="isDialogEditIndexShown"
        persistent
        width="500"
            >
            <v-card>
                <v-card-title
                    class="headline light-blue darken-4 text-light"
                    primary-title
                >
                    <v-icon size='30px' color="white">settings</v-icon>
                    Edit Index PDPA
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="isDialogEditIndexShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="indexpdpa"
                            :rules="[rules.required]"
                            label="Index PDPA (example: pdpa or pdpa,device1,device2,...)"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        slot="activator"
                        class="white--text"
                        color="green darken-1"
                        depressed
                        style="outline: none;"
                        @click="addIndexPdpa">
                        Save
                        <v-icon size="30" right>save</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <!-- Dialog Custom field -->
    <div class="text-xs-center">
        <v-dialog
            v-model="isDialogCustomFieldShown"
            persistent
            width="700"
        >
            <v-card>
                <v-card-title
                    class="headline light-blue darken-4 text-light"
                    primary-title
                >
                    <v-icon size='30px' color="white" style="margin-right: 5px;">dashboard_customize</v-icon>
                    Custom data field in PDPA
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="isDialogCustomFieldShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="loadingGetFields">
                    <v-flex style="margin-top: 5%;" mb-5>
                        <v-progress-circular
                            :size="80"
                            :width="6"
                            color="light-blue accent-4"
                            indeterminate
                        />
                    </v-flex>
                    <span style="margin-left: 8px;">Loading ...</span>
                </v-card-text>
                <v-card-text v-else>
                    <v-layout row  style="padding: 0 50px;">
                        <v-flex>
                            <v-autocomplete
                                v-for="(item, index) in pdpaFieldsUser"
                                v-model="item.value"
                                :key="index"
                                :items="pdpaFieldsItems"
                                placeholder="Select PDPA Field"
                            >
                               <v-slide-x-reverse-transition
                                    slot="append-outer"
                                    mode="out-in"
                                >
                                <v-icon
                                    :color="'warning'"
                                    @click="pdpaFieldsUser.splice(index, 1)"
                                    v-text="'delete'"
                                />
                                </v-slide-x-reverse-transition>
                            </v-autocomplete>
                            <!-- <v-text-field v-model="indexpdpa"
                                    :rules="[rules.required]"
                                    label="Index PDPA (example: pdpa or pdpa,device1,device2,...)"/> -->
                            <v-tooltip bottom>
                                <v-btn
                                    slot="activator"
                                    flat
                                    icon
                                    style="outline: none;"
                                    @click="addCustomField" >
                                    <v-icon size="28" color="blue-grey darken-4">add</v-icon>
                                </v-btn>
                                <span>Add field</span>
                            </v-tooltip>
                        </v-flex>
                        <!-- <v-flex>
                            <h1>test</h1>
                        </v-flex> -->
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        slot="activator"
                        class="white--text"
                        color="green darken-1"
                        depressed
                        style="outline: none;"
                        @click="saveCustomField">
                        Save
                        <v-icon size="30" right>save</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog
        v-model="isDialogConfirmDeleteActivityShown"
        persistent
        width="500"
        >
        <v-card>
            <v-card-title
            class="headline blue darken-4 text-light"
            primary-title
            >
            Confirm Delete Activity Tracking
            </v-card-title>

            <v-card-text class="text-md-left">
                <p>Are you sure Delete Activity Tracking Alert Yes or No</p>
            </v-card-text>

            <v-card-actions>
            <v-spacer />
            <v-btn
                color="text-light red darken-1"
                style="outline: none;"
                @click="isDialogConfirmDeleteActivityShown = false"
            >
                No
            </v-btn>
            <v-btn
                class="text-light green darken-2"
                style="outline: none;"
                @click="conDeleteSettingAlert"
            >
                Yes
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>

    <!-- Dialog Add/Edit Alert -->
    <div class="text-xs-center">
        <v-dialog
            v-model="isDialogSettingAlertShown"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title
                    class="headline light-blue darken-4 text-light"
                    primary-title
                >
                    <v-icon size='30px' color="white" style="margin-right: 5px;">settings</v-icon>
                    {{textDialog}} Email Responsible person
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="isDialogSettingAlertShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="email"
                            :rules="[rules.required]"
                            label="E-mail (example: ilog@email.com)"/>
                    <v-select v-model="settimealert"
                        :items="settimealert_item"
                        :rules="[rules.required]"
                        label="Time" />
                    <v-select v-model="setOnOffAlert"
                        :items="setOnOffAlert_item"
                        label="Alert" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        v-if="textDialog == 'Add'"
                        slot="activator"
                        class="white--text"
                        color="green darken-1"
                        depressed
                        style="outline: none;"
                        @click="saveSetAlert">
                        Save
                        <v-icon size="30" right>save</v-icon>
                    </v-btn>
                    <v-btn
                        v-else
                        slot="activator"
                        class="white--text"
                        color="green darken-1"
                        depressed
                        style="outline: none;"
                        @click="conEditSettingOneAlert">
                        Save
                        <v-icon size="30" right>save</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <!-- Data Table -->
    <v-layout row justify-center>
        <v-flex lg12 md12>
            <v-card dark>
                <v-card-title>
                    PDPA Management control
                <v-spacer />
                <v-flex lg1 md1 style="top: 10px; position: relative; margin-right: 20px;">
                  <v-select
                    v-model="partner"
                    :items="partner_item"
                    label="Partner"
                  />
                </v-flex>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details />
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="datatables"
                    :search="search"
                    :custom-filter="customFilter"
                    :loading="loadTable"
                    :pagination.sync="pagination">
                <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.item.instance }}</td>
                    <td class="text-xs-center">{{ props.item.partner }}</td>
                    <td class="text-xs-center">{{ props.item.username }}</td>
                    <td  class="text-xs-center">
                        <v-tooltip bottom>
                            <v-btn
                                slot="activator"
                                flat
                                icon
                                style="outline: none;"
                                @click="buildPDPACollection(props.item)" >
                                <v-icon size="24" color="red lighten-2">construction</v-icon>
                            </v-btn>
                            <span>Build PDPA Collection</span>
                        </v-tooltip>
                    </td>
                    <td  class="text-xs-center">
                        <v-tooltip bottom>
                            <v-btn
                                slot="activator"
                                flat
                                icon
                                style="outline: none;"
                                @click="editIndexPdpa(props.item)" >
                                <v-icon size="24" color="green lighten-1">edit</v-icon>
                            </v-btn>
                            <span>Edit index PDPA</span>
                        </v-tooltip>
                    </td>
                    <td  class="text-xs-center">
                        <v-tooltip bottom>
                            <v-btn
                                slot="activator"
                                flat
                                icon
                                style="outline: none;"
                                @click="customFields(props.item)" >
                                <v-icon size="24" color="yellow lighten-2">dashboard_customize</v-icon>
                            </v-btn>
                            <span>Custom data fields</span>
                        </v-tooltip>
                    </td>
                    <td class="text-xs-center">
                        <div id="btn-box">
                            <v-switch
                                v-model="props.item.pdpacontrol.dashboard"
                                :label="props.item.pdpacontrol.dashboard ? 'On':'Off'"
                                color="success"
                                @change="changStateBtn(props.item)"
                                hide-details
                                >
                            </v-switch>
                        </div>
                    </td>
                    <td class="text-xs-center">
                        <div id="btn-box">
                            <v-switch
                                v-model="props.item.pdpacontrol.addlist"
                                :label="props.item.pdpacontrol.addlist ? 'On':'Off'"
                                color="success"
                                @change="changStateBtn(props.item)"
                                hide-details
                                >
                            </v-switch>
                        </div>
                    </td>
                    <td  class="text-xs-center">
                        <v-tooltip bottom>
                            <v-btn
                                slot="activator"
                                flat
                                icon
                                style="outline: none;"
                                @click="editSettingAlert(props.item.instance)" >
                                <v-icon size="24" color="light-blue lighten-2">manage_accounts</v-icon>
                            </v-btn>
                            <!-- <v-icon size="28" @click="editUser(props.item)" >edit_note</v-icon> -->
                            <span>Edit User Alert</span>
                        </v-tooltip>
                        <!-- <v-icon style="margin-left: 20%;" @click="editSettingAlert(props.item.instance)" >manage_accounts</v-icon> -->
                    </td>
                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>

    <v-snackbar
        v-model="snackbar"
        :bottom="false"
        :left="false"
        :multi-line="true"
        :right="false"
        :timeout="5000"
        :top="true"
        :vertical="false">
    {{ snackbartext }}
        <v-btn
            color="pink"
            flat
            style="outline: none;"
            @click="snackbar = false">
        Close
        </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'
export default {
  name: 'pdpacontrol',
  data () {
    return {
        snackbar: true,
        snackbartext: 'Warning!! Before enable dashboard and setting PDPA. Please click build first!',
        loadTable: false,
        loadTableSettingAlert: false,
        search: '',
        headers: [
            {
                text: 'Instance',
                value: 'instance',
                align: 'center',
                sortable: true
            },
            {
                text: 'Partner',
                value: 'partner',
                align: 'center',
                sortable: true
            },
            {
                text: 'Username',
                value: 'username',
                align: 'center',
                sortable: true
            },
            {
                text: 'Build',
                value: 'build',
                align: 'center',
                class: 'red--text',
                sortable: false
            },
            {
                text: 'Index',
                value: 'index',
                align: 'center',
                class: 'green--text',
                sortable: false
            },
            {
                text: 'Custom Fields',
                value: 'custom',
                align: 'center',
                class: 'yellow--text',
                sortable: false
            },
            {
                text: 'Dashboard',
                value: 'dashboard',
                align: 'center',
                sortable: true
            },
            {
                text: 'Add User',
                value: 'addlist',
                align: 'center',
                sortable: true
            },
            {
                text: 'Setting Alert',
                value: 'setting',
                align: 'center',
                class: 'blue--text',
                sortable: false
            }
        ],
        headersSettingAlert: [
            {
                text: 'Email',
                value: 'email',
                align: 'center',
                class: 'white--text body-2 light-blue lighten-1',
                sortable: true
            },
            {
                text: 'Time',
                value: 'time',
                align: 'center',
                class: 'white--text body-2 light-blue lighten-1',
                sortable: true
            },
            {
                text: 'Send Email',
                value: 'sendemail',
                align: 'center',
                class: 'white--text body-2 light-blue lighten-1',
                sortable: true
            },
            {
                text: 'Action',
                value: 'action',
                align: 'center',
                class: 'white--text body-2 light-blue lighten-1',
                sortable: false
            }
        ],
        pagination: {
            descending: false,
            rowsPerPage: 10,
            sortBy: 'instance'
        },
        paginationSettingAlert: {
            descending: false,
            rowsPerPage: 5,
            sortBy: 'email'
        },
        datatables: [],
        settingAlertable: [],
        userDetail: {},
        devicename: '',
        isDialogEditSettingPDPAShown: false,
        isDialogSettingAlertShown: false,
        isDialogConfirmDeleteActivityShown: false,
        isDialogEditIndexShown: false,
        isDialogCustomFieldShown: false,
        email: '',
        settimealert: '',
        settimealert_item: [
            {
                text: '1 นาที',
                value: '1m'
            },
            {
                text: '5 นาที',
                value: '5m'
            },
            {
                text: '10 นาที',
                value: '10m'
            },
            {
                text: '15 นาที',
                value: '15m'

            },
            {
                text: '30 นาที',
                value: '30m'
            },
            {
                text: '1 ชั่วโมง',
                value: '1h'
            },
            {
                text: '12 ชั่วโมง',
                value: '12h'
            },
            {
                text: '1 วัน',
                value: '1d'
            }
        ],
        setOnOffAlert: false,
        setOnOffAlert_item: [
            {
                text: 'On',
                value: true
            },
            {
                text: 'Off',
                value: false
            }
        ],
        rules: {
            required: v => !!v || 'This field is required.',
            min: v => v.length >= 6 || 'Min 6 characters'
        },
        instance: '',
        id: '',
        username: '',
        textDialog: '',
        partner: 'All',
        partner_item: [
            {
                text: 'All',
                value: 'All'
            },
            {
                text: 'AIS',
                value: 'AIS'
            },
            {
                text: 'INET',
                value: 'INET'
            },
            {
                text: 'DIRECT',
                value: 'DIRECT'
            }
        ],
        indexpdpa: 'pdpa',
        loadingGetFields: true,
        pdpaFieldsUser: [],
        pdpaFieldsItems: ['@timestamp', 'username', 'hostname', 'action', 'filename', 'ilogtype', 'database_type', '_raw'],
        token: null,
        ampid: null
    }
  },
  created () {
        this.token = sessionStorage.getItem('user-token')
        let decoded = jwtDecode(this.token)
        this.ampid = decoded.ampid
        this.getdataTable()
  },
  methods: {
    customFilter (value, search) {
        if (search !== '') {
            let regex = new RegExp(search)
            value = value.filter(el => regex.test(el.instance) || regex.test(el.partner) || regex.test(el.username))
        }
        if (this.partner !== 'All') {
            value = value.filter(el => el.partner === this.partner)
            return value
        } else {
            return value
        }
    },
    async getdataTable () {
        this.loadTable = true
        let response = await axios.get(apiUrl + '/api/whitelist/pdpaDataUsers')
        this.datatables = response.data
        this.loadTable = false
    },
    editSettingAlert (e) {
        this.instance = e
        this.settingAlertable = []
        this.getSettingAlert()
        this.isDialogEditSettingPDPAShown = true
    },
    async getSettingAlert () {
        this.loadTableSettingAlert = true
        let response = await axios.post(apiUrl + '/api/whitelist/getSettingPdpaAlert', {
            instance: this.instance
        })
        // console.log(response.data)
        this.settingAlertable = response.data.settingalert
        this.loadTableSettingAlert = false
    },
    async changStateBtn (e) {
        console.log('teset')
        window.analytics.track(`[Administrator][PDPA][Dashboard]`, {
            value: {
                username: e.username
            }
        },
        {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        await axios.post(apiUrl + '/api/whitelist/editStateControl', {
            _id: e._id,
            username: e.username,
            pdpacontrol: e.pdpacontrol
        })
    },
    addSettingAlert () {
        this.email = ''
        this.settimealert = '15m'
        this.setOnOffAlert = false
        this.textDialog = 'Add'
        this.isDialogSettingAlertShown = true
    },
    async saveSetAlert () {
        this.isDialogSettingAlertShown = false
        if (this.email && this.settimealert) {
            await axios.post(apiUrl + '/api/whitelist/addemailalert', {
                instance: this.instance,
                command: 'admin',
                email: this.email,
                time: this.settimealert,
                sendemail: this.setOnOffAlert
            })
            this.getSettingAlert()
            this.snackbartext = `Add setting email ${this.email} success`
            this.snackbar = true
        }
    },
    deleteSettingAlert (e) {
        console.log(e)
        this.email = e.email
        this.id = e._id
        this.isDialogConfirmDeleteActivityShown = true
    },
    async conDeleteSettingAlert () {
        this.isDialogConfirmDeleteActivityShown = false
        await axios.post(apiUrl + '/api/whitelist/deleteActivityTracking', {
            instance: this.instance,
            command: 'admin',
            id: this.id,
            email: this.email
        })
        this.getSettingAlert()
        this.snackbartext = `Delete setting email ${this.email} success`
        this.snackbar = true
    },
    async switchBTNSettingOneAlert (e) {
        await axios.post(apiUrl + '/api/whitelist/editSetAlert', {
            instance: this.instance,
            command: 'admin',
            id: e._id,
            email: e.email,
            time: e.time,
            sendemail: e.sendemail
        })
        this.getSettingAlert()
        this.snackbartext = `Setting email ${this.email} success`
        this.snackbar = true
    },
    editSettingOneAlert (e) {
        this.email = e.email
        this.settimealert = e.time
        this.setOnOffAlert = e.sendemail
        this.id = e._id
        this.textDialog = 'Edit'
        this.isDialogSettingAlertShown = true
    },
    async conEditSettingOneAlert () {
        window.analytics.track(`[Administrator][PDPA][Setting_Alert]`, {
            value: {
                 instance: this.instance
            }
        },
        {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        this.isDialogSettingAlertShown = false
        await axios.post(apiUrl + '/api/whitelist/editSetAlert', {
            instance: this.instance,
            command: 'admin',
            id: this.id,
            email: this.email,
            time: this.settimealert,
            sendemail: this.setOnOffAlert
        })
        this.getSettingAlert()
        this.snackbartext = `Edit setting email ${this.email} success`
        this.snackbar = true
    },
    async buildPDPACollection (e) {
        window.analytics.track(`[Administrator][PDPA][Build]`, {
            value: {
                username: e.username,
                instance: e.instance
            }
        },
        {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        let response = await axios.post(apiUrl + '/api/whitelist/buildPdpa', {
            id: e._id,
            username: e.username,
            instance: e.instance
        })
        if (response.data.msg === 'success') {
            this.snackbartext = `Build PDPA Collection successfully`
            this.snackbar = true
        } else {
            this.snackbartext = `Please refresh page and try again`
            this.snackbar = true
        }
    },
    async editIndexPdpa (e) {
        try {
            let indexpdpa = await axios.post(apiUrl + '/api/query/getAllIndex', {
                instance: e.instance,
                command: 'controlpdpa'
            })
            this.instance = e.instance
            this.indexpdpa = 'pdpa'
            indexpdpa.data.map(el => {
                this.indexpdpa += ',' + el
            })
            this.isDialogEditIndexShown = true
        } catch (error) {
            this.snackbartext = error
            this.snackbar = true
        }
    },
    async addIndexPdpa () {
        this.isDialogEditIndexShown = false
        let index = this.indexpdpa.split(',')
        await axios.post(apiUrl + '/api/whitelist/editIndexPdpa', {
            index: index,
            instance: this.instance
        })
        window.analytics.track(`[Administrator][PDPA][index]`, {
            value: {
                index: index,
                instance: this.instance
            }
        },
        {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        this.snackbartext = `Edit index PDPA successfully`
        this.snackbar = true
    },
    async customFields (e) {
        this.isDialogCustomFieldShown = true
        this.loadingGetFields = true
        this.instance = e.instance
        this.username = e.username
        this.pdpaFieldsUser = []
        this.pdpaFieldsItems = []
        try {
            let response = await axios.post(apiUrl + '/api/whitelist/customFields', {
                command: 'getFromLog',
                instance: e.instance
            })
            this.pdpaFieldsItems = response.data
        } catch (error) {
            this.snackbartext = error
            this.snackbar = true
        }
        try {
            let responseUser = await axios.post(apiUrl + '/api/whitelist/customFields', {
                command: 'getFromUser',
                instance: e.instance
            })
            if (responseUser.data.length !== 0) {
                this.pdpaFieldsUser = responseUser.data
            } else {
                this.pdpaFieldsUser.push({
                    text: '',
                    value: ''
                })
            }
        } catch (error) {
            this.snackbartext = error
            this.snackbar = true
        }
        // console.log(this.pdpaFieldsItems)
        // console.log(this.pdpaFieldsUser)
        this.loadingGetFields = false
    },
    addCustomField () {
        this.pdpaFieldsUser.push({
            text: '',
            value: ''
        })
    },
    async saveCustomField () {
        window.analytics.track(`[Administrator][PDPA][Custom_Fields]`, {
            value: {
                username: this.username,
                instance: this.instance
            }
        },
        {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        let exField = []
        this.pdpaFieldsUser.map(item => {
            if (item.value !== '') {
                exField.push(item.value)
            }
        })
        try {
            await axios.post(apiUrl + '/api/whitelist/customFields', {
                command: 'update',
                username: this.username,
                instance: this.instance,
                fields: exField
            })
        } catch (error) {
            this.snackbartext = error
            this.snackbar = true
        }
        this.instance = ''
        this.username = ''
        this.isDialogCustomFieldShown = false
    }
  }
}
</script>

<style scoped>

#table {
    background-color: #fff;
}
#tabele-device {
    padding: 40px;
    margin: auto;
}

#add-device {
    padding-bottom: 40px;
    margin: auto;
}

#btn-box {
    width: 50%;
    margin: 0;
    padding: 0;
    margin-left: 35%;
}

#btn-box-inside{
    color: #000;
    text-transform: capitalize;
}
</style>>



// WEBPACK FOOTER //
// src/views/pdpaControl.vue